/**
 * Test if any items between two provided arrays exist in both arrays
 *
 * @param array1 First array to test
 * @param array2 Second array to test
 */
export const intersects = (array1, array2) => array1.some((value) => array2.includes(value));
/**
 * Returns all values that are present in both arrays
 *
 * @param array1 First array to test
 * @param array2 Second array to test
 */
export const intersection = (array1, array2) => array1.filter((value) => array2.includes(value));
/**
 * Filters out items that intersect between arrays
 *
 * @param array1 First array to compare
 * @param array2 Second array to compare
 */
export const filterIntersections = (array1, array2) => {
    const filteredArray1 = array1.filter((value) => !array2.includes(value));
    const filteredArray2 = array2.filter((value) => !array1.includes(value));
    return [...filteredArray1, ...filteredArray2];
};
